import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useKleosStore = defineStore('kleosStore', () => {
  // Popup state management (reactive)
  const isAuthenticated = ref<boolean>(false)

  const initializeFromStorage = () => {
    const stored = localStorage.getItem('kleos-auth-state')

    if (stored) {
      try {
        isAuthenticated.value = JSON.parse(stored) || false
      } catch (error) {
        console.error('Error parsing stored Kleos auth state:', error)
      }
    }
  }

  const saveToStorage = () => {
    try {
      localStorage.setItem('kleos-auth-state', JSON.stringify(isAuthenticated.value))
    } catch (error) {
      console.error('Error saving Kleos auth state to localStorage:', error)
    }
  }

  // Get current authentication state (non-reactive)
  const getAuthenticationState = () => {
    initializeFromStorage()
    return isAuthenticated.value
  }

  // Set authentication state to successful
  const setSuccessfulAuthenticationState = () => {
    isAuthenticated.value = true
    saveToStorage()
  }

  // Reset authentication state
  const resetAuthenticationState = () => {
    isAuthenticated.value = false
    // wait 2 seconds before removing the storage
    setTimeout(() => {
      removeStorage()
    }, 2000)
  }

  // remove the storage
  const removeStorage = () => {
    try {
      localStorage.removeItem('kleos-auth-state')
    } catch (error) {
      console.error('Error removing Kleos auth state from localStorage:', error)
    }
  }

  // Initialize on store creation
  initializeFromStorage()

  return {
    isAuthenticated,
    initializeFromStorage,
    saveToStorage,
    getAuthenticationState,
    setSuccessfulAuthenticationState,
    resetAuthenticationState,
    removeStorage
  }
})
